import { Component, LOCALE_ID, OnInit, inject } from '@angular/core';
import { MatTableDataSource, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { Router } from '@angular/router';
import { Hp } from 'src/app/models/hp.model';
import { Status } from 'src/app/models/status.model';
import { HpDataProviderService } from 'src/app/services/hp-data-provider.service';
import { HpService } from 'src/app/services/hp.service';
import { DatePipe } from '@angular/common';
import { ContentCardComponent } from '../../shared-modules/content-card/content-card.component';
import { MatSort, MatSortHeader } from '@angular/material/sort';

@Component({
    selector: 'app-hps',
    templateUrl: './hps.component.html',
    providers: [
        { provide: LOCALE_ID, useValue: 'nl' }
    ],
    styleUrls: ['./hps.component.scss'],
    imports: [ContentCardComponent, MatTable, MatSort, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatSortHeader, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, DatePipe]
})
export class HpsComponent implements OnInit {
  private hpService = inject(HpService);
  private hpDataProviderService = inject(HpDataProviderService);
  private router = inject(Router);

  public dataSource = new MatTableDataSource<Hp>
  public hpRetrieved: boolean = false;
  public displayedColumns: string[] = [
    'location',
    'locationId',
    'initiator',
    'motivation',
    'createdAt'
  ];;

  ngOnInit(): void {
    this.initHp();
  }

  public rowClicked(row: Hp) {
    this.saveHp(row);
  }

  private initHp() {
    this.hpService.getHps().subscribe(hps => {
      hps = hps.filter(hp => hp.status === Status.APPROVED);
      if (hps.length === 0) {
        console.error('Gebruiker is niet gekoppeld aan een handelingsperspectief');
      } else if (hps.length <= 1) {
        this.saveHp(hps[0]);
      }
      this.dataSource.data = hps;
      this.hpRetrieved = true;
    });
  }

  private saveHp(hp: Hp) {
    this.hpDataProviderService.removeHp();
    this.hpDataProviderService.updateLocalHp(hp);
    this.router.navigate(['/landing-page']);
  }
}
